import Background from '@/scripts/Slider/Background';

const background = {
  ref: null,

  init(DOMContainer, DOMCanvas) {
    background.ref = new Background(DOMContainer, DOMCanvas);
  },
};

export default background;
